/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import SummarySelector from '../summary/SummarySelector';
import { isStatusReadOnly } from '../../models/SubmissionStatus';
import SignatureCards from '../signature/SignatureCards';

const useStyles = makeStyles(() => ({
  preview: {
    height: '100vh',
  },
}));

export default function ConfirmationPreviewCanvas({ className, submission, previewObject, selectedCard, uiSchema }) {
  const classes = useStyles();

  let component;
  switch (selectedCard) {
    case 'summary':
      component = (
        <SummarySelector
          submission={submission}
          isSummary={true}
          uiSchema={uiSchema || {}}
          readOnly={isStatusReadOnly(submission?.status)}
          hideLinkTo={true}
        />
      );
      break;

    case 'signature':
      component = <SignatureCards readOnly submission={submission} />;
      break;

    case 'receipt':
      component = (
        <embed
          src={previewObject?.path}
          type="application/pdf"
          alt="pdf"
          width="100%"
          height="100%"
          className={classes.preview}
        />
      );
      break;
    default:
      if (['application/xml', 'text/xml'].includes(previewObject?.type)) {
        component = (
          <figure>
            <pre>{previewObject?.path}</pre>
          </figure>
        );
      } else {
        component = (
          <embed
            src={previewObject?.path}
            type="application/pdf"
            alt="pdf"
            width="100%"
            height="100%"
            className={classes.preview}
          />
        );
      }
      break;
  }
  return <div className={className}>{component}</div>;
}
